/* eslint-disable */
import {isProduction} from '@/utils';
import {getMemberMetaInfo, getMemberName, setMemberName} from '@/http';

export const PUBLIC_CHANNEL = '1234567';

function padDateField(num) {
  return num > 9 ? (num + '') : '0' + num;
}

function getTimeFormatted(date) {
  const year = date.getFullYear();
  const month = padDateField(date.getMonth() + 1);
  const dayOfMonth = padDateField(date.getDate());
  const hour = padDateField(date.getHours());
  const minute = padDateField(date.getMinutes());
  const second = padDateField(date.getSeconds());
  const no1Part = [year, month, dayOfMonth].join('-');
  const no2Part = [hour, minute, second].join(':');
  return [no1Part, no2Part].join(' ');
}

export const SharedRtmInfo = {
  data() {
    return {
      rtm: null,
      joinedChannels: {},
      publicChannel: PUBLIC_CHANNEL,
      senderChannel: null,
    };
  },
  methods: {
    rtmDefaultListeners(rtm) {
      rtm.on('ConnectionStateChanged', (newState, reason) => {
        // console.log('ConnectionStateChanged', newState, reason);
        this.onConnectionStateChanged(newState, reason);
      });
      rtm.on('MessageFromPeer', async (message, peerId) => {
        // console.log(message, peerId);
        this.onMessageFromPeer(message, peerId);
      });
      rtm.on('MemberJoined', ({channelName, args}) => {
        console.warn('Member join: ', channelName, args);
        if (channelName === PUBLIC_CHANNEL) {
          this.onJoinPublicChannel(channelName, args);
        } else {
          this.onJoinChannel(channelName, args);
        }
      });
      rtm.on('MemberLeft', ({channelName, args}) => {
        console.warn('Member left: ', channelName, args);
        if (channelName === PUBLIC_CHANNEL) {
          this.onLeftPublicChannel(channelName, args);
        } else {
          this.onLeftChannel(channelName, args);
        }
      });
      rtm.on('ChannelMessage', async (args) => {
        // console.log(args);
        this.onChannelMessage(args);
      });
    },
    rtmDefaultLogin(rtm, options) {
      const {accountId, token} = options;
      rtm.login(accountId, token).then(() => {
        // 客服一直在公共频道，用户进入公共频道三十秒后退出，这三十秒用于获取客服信息
        this.joinChannel(PUBLIC_CHANNEL);
        this.onLogin();
      });
    },
    lifeBeforeLeave() {
      const {joinedChannels, rtm} = this;
      if (!rtm) {
        return;
      }
      Object.keys(joinedChannels || {}).forEach(channel => {
        try {
          rtm.leaveChannel(channel);
        } catch (e) {
        }
      });
      try {
        rtm.logout();
      } catch (e) {
      }
      this.rtm = null;
    },
    joinChannel(channel) {
      const joined = this.rtm.joinChannel(channel);
      this.joinedChannels[channel] = joined;
    },
    leaveChannel(channel) {
      this.rtm.leaveChannel(channel);
    },
    sendPublicChannelMessage(message) {
      this.sendChannelMessage(message, PUBLIC_CHANNEL);
    },
    sendChannelMessage(message, channel) {
      if (!message) {
        return;
      }
      this.rtm.sendChannelMessage(message, channel);
    },
    sendPeerMessage(message, peerId) {
      const msg = JSON.stringify(message);
      return this.rtm.sendPeerMessage(msg, peerId);
    },
    afterInitClient(rtm) {
    },
    onLogin() {
    },
    onLogout() {
    },
    newMessageItem(message, peerId, type) {
      const date = new Date();
      const name = getMemberName(peerId);
      const detail = {
        type, peerId, name,
        text: message,
        time: date.getTime(),
        formatted: getTimeFormatted(date),
      };
      if (!name) {
        getMemberMetaInfo(peerId).then(name => {
          detail.name = name;
        });
      }
      return detail;
    },
    onConnectionStateChanged(channel, args) {
    },
    onMessageFromPeer(message, peerId) {
    },
    onJoinPublicChannel(channel, args) {
    },
    onJoinChannel(channel, args) {
    },
    onLeftPublicChannel(channel, args) {
    },
    onLeftChannel(channel, args) {
    },
    onChannelMessage(channel, args) {
    },
  },
  created() {
    if (isProduction()) {
      const rtm = new window.RTMClient();
      const {options} = this;
      rtm.init(options.appId);
      this.rtmDefaultListeners(rtm);
      this.rtmDefaultLogin(rtm, options);
      this.rtm = rtm;
      this.afterInitClient(rtm);
    }
    window.addEventListener('beforeunload', this.lifeBeforeLeave);
  },
  beforeUnmount() {
    this.lifeBeforeLeave();
  },
};